import { jsx as _jsx } from "react/jsx-runtime";
import { CustomButton, Spinner } from "./Button.styled";
var Button = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, variant = _a.variant, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, onClick = _a.onClick;
    if (!children)
        return null;
    var handleButtonClick = function () {
        if (disabled)
            return;
        if (onClick)
            onClick();
    };
    return (_jsx(CustomButton, { variant: variant || null, disabled: disabled || loading, onClick: handleButtonClick, fullWidth: fullWidth, children: loading ? _jsx(Spinner, {}) : children }));
};
export default Button;
//# sourceMappingURL=Button.js.map